<template>
    
    
   <div class="
    
      border-1 
      rounded-md
      shadow-xl
      
    ">
    <div class="lg:col-span-3 bg-white ">
        <div class="md:p-2 bg-white align-middle">
            <!--  <h1 class="text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-green-300 h-auto"> -->
            <h1 class="text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-br from-blue-400 to-purple-600 " style="font-size: 50px">
          Tube In Tube Heat Exchanger


            </h1>
        </div>
    </div>
</div>

    <div class="grid grid-cols-3 bg-white"> 
        <div> 
            <img src="https://alphatech-equip.com/static/img/products/tube_and_tube.jpg"> 
            </div> 
            <div class="col-span-2 text-left pl-10 mt-10"> 

    <ul> 
        <li> 
        

Made in stainless steel pipe </li> <li> 
It can be used for clear juice and crushed grapes </li> <li> 
Temperature difference- as per heating media </li> <li> 
Insulated with SS 304 cladding </li> <li> 
Stainless steel frame work. </li> <li> 
High Pressure Design. </li> <li> 
End Connection Flange End/Union. </li> <li> 
Smooth in operation. </li> <li> 
Mounted on wheel </li> 




 </ul> 

 </div> 

 </div> 




</template>